<template>
  <div class="navBox">
      <div class="name">
          <p class="">资源系统</p>
      </div>
      <div class="navList">
        <div class="navItem" v-for="item in navList" v-bind:key="item.id">
          <div class="item" :class="navID==item.id?'select':''" @click="navSub(item)">
            <i class="icon" :class="'icon'+item.id"></i>
            <p>{{item.label}}</p>
          </div>
          <div class="children" v-if="item.showType">
            <div class="item" v-for="ele in item.children" v-bind:key="ele.id" :class="ele.id==childrenID?'select':''" @click='childrenSub(ele)'>
              <p>{{ele.label}}</p>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
  export default {
      name: 'navBox',
      data() {
        return {
          navList: [
            {
              id:1,
              label: '词库管理',
              children:[
                {
                  id:'1-1',
                  label: '实词虚词',
                  url:'/resource?id=1-1',
                },
                {
                  id:'1-2',
                  label: '古诗文',
                  url:'/resource?id=1-2',
                },
                {
                  id:'1-3',
                  label: '英语',
                  url:'/resource?id=1-3',
                }
              ]
            },
            {
              id:6,
              label: '年纪学期管理',
              url:'/grade'
            },
            {
              id:2,
              label: '会员管理',
              url:'/vip'
            },
            {
              id:3,
              label: '资源包会员管理',
              url:'/pack'
            },
            {
              id:7,
              label: '资源包管理',
              url:'/packList'
            },
            {
              id:4,
              label: '徽章管理',
              url:'/badge'
            },
            {
              id:5,
              label: '积分管理',
              url:'/points'
            },
            {
              id:8,
              label: '意见反馈',
              url:'/feedback'
            },
          ],
          navID:'',
          childrenID:'',
          userData:'',
          url:''
        };
      },
      props: {
        title: String,
        visible: {
          type: Boolean,
          default: false
        },
        id: String,
        cid: String,
      },
      mounted() {
        // this.getUser();
        var that = this;
        this.navID = this.id;
        this.childrenID = this.cid;
        
        var url = '';
        if(window.location.origin == 'https://aimemoryweb.zens10.com'){
          url = 'https://aimemory.zens10.com/'
        } else {
          url = 'https://aimemorys.zens10.com/'
          // url = 'https://aimemorys.zens10.com/'
        };
        this.navChange();
        this.url = url;
      },
      methods: {
        navSub(e){
          var that = this;
          if(e.children){
            e.showType = !e.showType;
            // this.childrenID = e.id;
          };
          this.navID = e.id;
          this.$forceUpdate();
          if(e.url){
            this.$router.push(e.url);
          }
        },

        navChange(){
          var that = this;
          var list = this.navList;
          list.forEach(function(item,index){
            if(that.navID == item.id&&!item.children){
              document.title = item.label
            };
            if(item.children){
              item.children.forEach(function(ele,num){
                if(ele.id == that.childrenID){
                  item.showType = true;
                  document.title = ele.label;
                }
              })
            };
          });
          this.$forceUpdate();
        },

        childrenSub(e){
          var that = this;
          if(e.url){
            if(e.id == '1-1' || e.id == '1-2' || e.id == '1-3'){
              this.$router.replace({
                name:'resource',
                query:{id:e.id}
              },()=>{
                window.location.reload();
              })
            } else {
              this.$router.push(e.url);
            }
            
          }else {
            this.$message('暂无')
          }
        },

        getUser(){
          var that = this;
          var data = localStorage.getItem('userdata');
          this.userData = JSON.parse(data);
          if(data == null){
            this.$message('请先登录！');
            this.$router.push('/');
          }
          if(this.userData.level == 0){
            that.navList = [
              {
                id:5,
                label: '系统管理',
                children: [{
                  id:'5-4',
                  label: '开通机构和账号',
                  url:'/open'
                }]
              }
            ]
          } else {
          };
          if(this.userData.type == 2){//模拟卷
            that.navList = [
              {
                id:1,
                label: '考试管理',
                children: [{
                  id:'1-1',
                  label: '考试类型管理',
                  url:'/exam'
                },{
                  id:'1-2',
                  label: '考试列表',
                  url:'/examList'
                }]
              }, 
              {
                id:3,
                label: '学员管理',
                url:'/parent'
              },
              {
                id:6,
                label: '老师管理',
                url:'/teacher'
              },
              {
                id:8,
                label: '成绩管理',
                url:'/score'
              },
              {
                id:5,
                label: '系统管理',
                children: [{
                  id:'5-1',
                  label: '后台帐号管理',
                  url:'/admin'
                },{
                  id:'5-2',
                  label: '角色管理',
                  url:'/power'
                },{
                  id:'5-3',
                  label: '账户信息',
                  url:'/account'
                }]
              },
              {
                id:4,
                label: '会员管理',
                url:'/vipList'
              },
              {
                id:7,
                label: '营销管理',
                children: [{
                  id:'7-1',
                  label: 'banner',
                  url:'/market'
                },
                {
                  id:'7-2',
                  label: '意见反馈',
                  url:'/feedback'
                }
              ]
              },
            ]
          }
        }
      }
  }
</script>
<style scoped>
  
</style>


// WEBPACK FOOTER //
// src/components/comment/nav.vue